import { IAddressEntity } from './adress.entity.interface';

export class AddressEntity implements IAddressEntity {
  readonly streetName: string;
  readonly postalCode: string;
  readonly provinceName: string;
  readonly cityName: string;
  readonly countryName: string;

  constructor(data: IAddressEntity) {
    this.streetName = data.streetName;
    this.postalCode = data.postalCode;
    this.provinceName = data.provinceName;
    this.cityName = data.cityName;
    this.countryName = data.countryName;
  }
}
